export const SET_PLAYBACK_ACTION = "SET_PLAYBACK_ACTION";
export const SET_SAVED_ALBUMS_LOADING_PROGRESS = "SET_SAVED_ALBUMS_LOADING_PROGRESS";
export const SET_CLEARING_QUEUE = "SET_CLEARING_QUEUE";
export const SET_TOO_MANY_REQUESTS_COOLDOWN = "SET_TOO_MANY_REQUESTS_COOLDOWN";

export const setPlaybackAction = payload => ({ type: SET_PLAYBACK_ACTION, payload});
export const setSavedAlbumsLoadingProgress = payload => ({ type: SET_SAVED_ALBUMS_LOADING_PROGRESS, payload });
export const setClearingQueue = payload => ({ type: SET_CLEARING_QUEUE, payload });
export const setTooManyRequestsCooldown = payload => ({ type: SET_TOO_MANY_REQUESTS_COOLDOWN, payload });